module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-link-d039c36accab2f3597d3172685c45b7f.svg";